<template>
    <div class="fallback">
        <h3>{{ $t('feedback.fallbackHeader') }}</h3>
        <p>{{ $t('feedback.fallbackDescription') }}</p>
        <a
            :href="$t('zendesk')"
            target="_blank"
            rel="noopener noreferrer"
        >
            {{ $t('feedback.fallbackLinkText') }}
        </a>
    </div>
</template>

<script>
export default {
    name: 'TheFallback',
};
</script>